import BN from 'bignumber.js'
import React, { InputHTMLAttributes } from 'react'
import styled from 'styled-components/macro'

import Text from '../Text/index'

export const getDisplayBalance = (balance: any, decimals = 18) => {
  const displayBalance = new BN(balance)
  if (displayBalance.gt(0) && displayBalance.lte(0.01)) {
    return '< 0.01'
  }
  return new BN(new BN(displayBalance).toFixed(2, 1)).toString(10)
}

interface TokenInputProps extends InputHTMLAttributes<HTMLInputElement> {
  max: number | string
  symbol: string
  value: string
  onSelectMax?: () => void
  onChange: (evt: React.FormEvent<HTMLInputElement>) => void
}

const Input = styled.input<{ error?: boolean; fontSize?: string }>`
  font-size: ${({ fontSize }) => fontSize || '1.25rem'};
  outline: none;
  border: none;
  flex: 1 1 auto;
  width: 0;
  background-color: ${({ theme }) => theme.deprecated_bg1};
  transition: color 300ms ${({ error }) => (error ? 'step-end' : 'step-start')};
  color: ${({ error, theme }) => (error ? theme.accentFailure : theme.textPrimary)};
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
  width: 100%;
  padding: 0px;
  -webkit-appearance: textfield;

  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  ::placeholder {
    color: ${({ theme }) => theme.deprecated_text4};
  }
`

const Box = styled.div``
const Flex = styled.div<{
  justifyContent?: string
  alignItems?: string
  minHeight?: string
  mb?: string
}>`
  display: flex;
  justify-content: ${({ justifyContent }) => justifyContent || 'space-between'};
  align-items: ${({ alignItems }) => alignItems || 'center'};
  min-height: ${({ minHeight }) => minHeight || 'auto'};
  margin-bottom: ${({ mb }) => mb || '0'};
`

const MaxButton = styled.button`
  background: #e1faf4;
  width: 42px;
  height: 30px;
  color: #14d89d;
  border-radius: 4px;
  box-shadow: none;
  font-size: 14px;
  cursor: pointer;
  outline: none;
  border: none;
`

const TokenInput: React.FC<TokenInputProps> = ({ max, symbol, onChange, onSelectMax, value }) => {
  return (
    <Box style={{ border: ' 1px solid rgba(115, 126, 141, 0.16)', borderRadius: '12px', padding: '24px' }}>
      <Flex justifyContent="space-between" minHeight="21px" mb="8px">
        <Text color="#666" fontSize="14px">
          Stake
        </Text>
        <Text color="#666" fontSize="14px">
          Balance:
          {getDisplayBalance(new BN(max))}
        </Text>
      </Flex>
      <Flex alignItems="center">
        <Input
          onChange={onChange}
          placeholder="0"
          value={value}
          style={{ border: 'none', padding: '0', background: 'white' }}
        />
        <Flex alignItems="center">
          <div>
            <MaxButton onClick={onSelectMax}>
              <Text color="#14d89d" fontSize="14px">
                MAX
              </Text>
            </MaxButton>
          </div>
          <Text color="#01142A" textTransform="uppercase" style={{ marginLeft: '10px' }}>
            {symbol}
          </Text>
        </Flex>
      </Flex>
    </Box>
  )
}

export default TokenInput
